module.exports = __webpack_public_path__ + "img/header-memoireRings.df53f45.webp";